import { useQuery } from "@tanstack/react-query";
import { getVideoHeatmapRender, getVideoOriginalRender } from "./api";
import { RendererBaseParams } from "./types/renderer.type";

/**
 * useGetVideoOriginalRender Query
 *
 * Fetches a short-lived pre-signed S3 URL for a video's original render, for playback in the
 * in-depth video player. The URL expires after an hour (api-vid-renderer's OriginalHandler).
 *
 * Query Key: [projectId, studyId, assetKey, "video-original-render"]
 */
export const useGetVideoOriginalRender = ({ projectId, studyId, assetKey }: RendererBaseParams) => {
  return useQuery({
    queryKey: [projectId, studyId, assetKey, "video-original-render"],
    throwOnError: true,
    queryFn: () => getVideoOriginalRender({ projectId, studyId, assetKey }),
  });
};

/**
 * useGetVideoHeatmapRender Query
 *
 * Fetches a short-lived pre-signed S3 URL for a video's attention heatmap-overlay render, for the
 * player's original/heatmap toggle. Enabled by default so the player can preload it in the
 * background - pass options.enabled: false to opt out for a caller that doesn't need that.
 *
 * Query Key: [projectId, studyId, assetKey, "video-heatmap-render"]
 */
export const useGetVideoHeatmapRender = ({ projectId, studyId, assetKey }: RendererBaseParams, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [projectId, studyId, assetKey, "video-heatmap-render"],
    throwOnError: true,
    queryFn: () => getVideoHeatmapRender({ projectId, studyId, assetKey }),
    ...options,
  });
};
